import React, { useEffect, useState } from 'react'
import EditDetailStyles from './EditCompanyDetail.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
const EditCompanyDetail = () => {
  // get data from redux
  const name=useSelector((state)=>state.globalData.name);
  const count=useSelector((state)=>state.globalData.notificationCount);
  const dispatch =  useDispatch()
    const location = useLocation()
    const data = location.state
    console.log(data)

    const navigate = useNavigate()

    const inputRef = React.useRef();

    const [file, setFile] = useState(null)
    const [source, setSource] = React.useState();
    const [previewUrl, setPreviewUrl] = useState('');
    const [fileName, setFileName] = React.useState('');
    const [pdfSelect, setPdfSelect] = useState(false)

    const [companyDetailsHeading, setCompanyDetailsHeading] = useState('')

    useEffect(() => {
        if (data) {
            setCompanyDetailsHeading(data.companyDetails?.companyDetailsHeading)
        }
    }, [data])



    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFileName(file.name)
        const url = URL.createObjectURL(file);
        setSource(url);
        setPdfSelect(true)
        setFile(file)
    };

    const handlePdfChange = (event) => {
        const selectedFile = event.target.files[0]
        setFile(selectedFile)
        setPreviewUrl(URL.createObjectURL(selectedFile))
        setPdfSelect(true)
    }

    const handleChoose = (event) => {
        inputRef.current.click();
    };

    const discardPdf = (event) => {
        // setSource(null)
        // setFileName('')
        setPreviewUrl('')
        setFile(null)
        inputRef.current.value = ""
        setPdfSelect(false)
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        const formDataObj = new FormData()
        formDataObj.append("file", file)
        formDataObj.append("companyDetailsHeading", companyDetailsHeading)

        try {
            const pdfResponse = await axios.post(
                `${process.env.REACT_APP_COSMOSADMIN}/companydetails/updatePdfbyId/${data.pdfId}`,
                formDataObj,
                {
                    headers: {
                        "Content-Type": "application/pdf"
                    }
                }
            )
            console.log(pdfResponse)

            const detailResponse = await axios.post(
                `${process.env.REACT_APP_COSMOSADMIN}/companydetails/updateCompanyDetails/${data.companyDetails.companyDetailsId}`,
                { companyDetailsHeading },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
                // this is the snipte for the notification

       const dateTime=detailResponse.data.date;

       const [dateString,timeString]=dateTime.split("T");

       const date=new Date(dateString);

       const time=timeString.substr(0,8);


       const localDate=date.toLocaleDateString();

       dispatch(setNotifications({
           notification:{
             name:name,
             details:detailResponse.data.message,
             time:time,
             date:localDate
           }
         }))
         dispatch(setNotificationCount({
          count:count+1,
         }))
         
       //   uptill here 
            console.log('Detail Updated.')
            console.log(detailResponse)
            alert('Detail Updated.')
            discardPdf()
            navigate('/companydetails')
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className={EditDetailStyles.editDetailMain}>
            <div className={EditDetailStyles.editDetailContent}>
                <form action="" className={EditDetailStyles.editDetailForm} onSubmit={handleSubmit} encType='multipart/form-data'>
                    <label className={EditDetailStyles.editDetailFormLabel}>Title</label>
                    <input className={EditDetailStyles.editDetailFormText} type="text" value={companyDetailsHeading } name='companyDetailsHeading' onChange={(event) => setCompanyDetailsHeading(event.target.value)} />
                    <label className={EditDetailStyles.editDetailFormLabel}>Choose a PDF:</label>
                    <div className={EditDetailStyles.ImgInput}>
                        <input
                            ref={inputRef}
                            className={EditDetailStyles.ImgInput_input}
                            type="file"
                            onChange={handlePdfChange}
                        />
                        {!previewUrl && <button type='button' onClick={handleChoose}>Browse</button>}
                        {previewUrl && (
                            // <img
                            //     className={EditDetailStyles.ImgInput_img}
                            //     width="100%"
                            //     src={source}
                            //     alt='uploadedimage'
                            // />
                            <iframe src={previewUrl} width="100%" height="500px" title="PDF Preview" />
                        )}
                        <div className={EditDetailStyles.ImgInput_footer}> {pdfSelect ?
                                <div >
                                    {fileName}
                                    <DeleteForeverOutlinedIcon onClick={discardPdf} sx={{ cursor: 'pointer' }} />
                                </div> :
                                ''}
                        </div>
                    </div>
                    <Button variant='contained' type='submit' className={EditDetailStyles.saveChanges}>Save changes</Button>
                </form>
            </div>
        </div>
    )
}

export default EditCompanyDetail